import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import moment from 'moment'
import { HELVETICA, GRAY } from '../../../../styles'
import instagramLogo from '../../../../../assets/instagramLogo.png'

const Container = styled.div`
  flex: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: solid 0.5px #e8e8e8;
`
const CaptionContainer = styled.div`
  flex: 6;
  margin-top: 5px;
  width: 90%;
  word-break: break-all;
  overflow: auto;
`
const BottomContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${HELVETICA}
  font-size: 8px;
  font-weight: 500;
  letter-spacing: 0.4px;
  color: ${GRAY};
  width: 90%;
`
const InstaName = styled.div`
  background-image: url('${props => props.image}');
  background-repeat: no-repeat;
  background-size: contain;
  height: 10px;
  width: 10px;
  margin-right: 5px;
`
const NameContainer = styled.div`
  display: flex
`


const IPCCaption = ({caption, onClick, date, instaName}) => {
  return (
    <Container onClick={onClick}>
      <CaptionContainer>
        {caption}
      </CaptionContainer>
      <BottomContainer>
        <div>{moment(Number(date) * 1000).format('MMMM D, YYYY')}</div>
        <NameContainer>
          <InstaName image={instagramLogo} />
          {instaName}
        </NameContainer>
      </BottomContainer>

    </Container>
  )
}

IPCCaption.defaultProps = {
  onClick: () => null,
  caption: '',
  date: '',
  instaName: ''
}

IPCCaption.propTypes = {
  caption: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  date: PropTypes.string,
  instaName: PropTypes.string
}

export default IPCCaption



// WEBPACK FOOTER //
// ./src/components/editor/insta/instaTagPosts/instaPostCard/IPCCaption.js